import { Box, Flex, Text } from '@chakra-ui/react';
import { FunctionComponent, useMemo, useState } from 'react';
import { FILE_UPLOAD_STATUS, getClientUploadConfig } from '@/constants';
import { StepPageLayout } from '@/layouts/StepPageLayout';
import { useAppSelector } from '@/redux';
import { SelectedUploadFile } from '@/types/upload';
import { WaveDetailsPanel } from './components/WaveDetailsPanel';
import { WaveProgressPanel } from './components/WaveProgressPanel';
import { useDataProcessingJob } from './useDataProcessingJob';

export const WaveUploadPage: FunctionComponent = () => {
  const selectedClient = useAppSelector((state) => state.wave.selectedClient);
  const uploadConfig = useMemo(() => getClientUploadConfig(selectedClient?.clientName), [selectedClient]);
  const [files, setFiles] = useState<SelectedUploadFile[]>([]);
  const isFileUploading = files.some((item) => item.status === FILE_UPLOAD_STATUS.UPLOADING);
  const { isSucceeded } = useDataProcessingJob();

  if (!selectedClient) {
    return (
      <Box p={8}>
        <Text color="marketcast.text.primary">Client not found</Text>
      </Box>
    );
  }

  return (
    <StepPageLayout currentStep={1} isNextEnabled={isSucceeded} isBackEnabled={!isFileUploading}>
      <Flex
        h="100%"
        gap={6}
        p={6}
        direction={{ base: 'column', lg: 'row' }}
        overflowY={{ base: 'auto', lg: 'hidden' }}
      >
        <Box flex={{ lg: 2 }} minW={0} overflowY={{ lg: 'auto' }}>
          <WaveDetailsPanel
            uploadConfig={uploadConfig}
            files={files}
            setFiles={setFiles}
            isUploading={isFileUploading}
          />
        </Box>
        <Box flex={{ lg: 1 }} minW={0} overflowY={{ lg: 'auto' }}>
          <WaveProgressPanel
            maxFiles={uploadConfig.maxFiles}
            files={files}
            setFiles={setFiles}
            isUploading={isFileUploading}
          />
        </Box>
      </Flex>
    </StepPageLayout>
  );
};
